<div class="landing-page">
  <!-- Report Builder Section -->
  <div class="landing-page-section report-builder">
    <h2 class="header-text">Report Builder</h2>
    <div class="landing-page-section-text">
      <p class="body-text">Start building a report by leveraging your resource set and plan data. From there, you can
        easily customize, pivot, share and export your report.</p>
      <button pButton type="button" label="Build a Report" class="redirect-button"
        (click)="buildersMenu.toggle($event)"></button>
      <p-menu #buildersMenu [model]="builderItems" [popup]="true">
        <ng-template #item let-item>
          <a pRipple class="flex items-center p-menu-item-link">
            <i [class]="item.icon" class="text-primary"></i>
            <span class="ml-2 font-normal">{{ item.label }}</span>
            <i class="pi pi-angle-right text-primary ml-auto"></i>
          </a>
        </ng-template>
      </p-menu>
    </div>
    <div class="landing-page-section-image">
      <img src="assets/images/build-reports-{{ theme() }}.svg" alt="Build a report"
        class="landing-page-section-image" />
    </div>
  </div>

  <!-- Saved Reports Section -->
  <div class="landing-page-section saved-reports">
    <div class="landing-page-section-image">
      <img src="assets/images/saved-reports-{{ theme() }}.svg" alt="Saved Reports" class="landing-page-section-image" />
    </div>
    <h2 class="header-text">Saved Reports</h2>
    <div class="landing-page-section-text">
      <p class="body-text">Browse, search, and access saved reports. You can quickly access reports saved by you and
        those shared by your team.</p>
      <button pButton type="button" label="View Saved Reports" class="redirect-button"
        (click)="reportsMenu.toggle($event)"></button>
      <p-menu #reportsMenu [model]="reportItems" [popup]="true">
        <ng-template #item let-item>
          <a pRipple class="flex items-center p-menu-item-link">
            <i [class]="item.icon" class="text-primary"></i>
            <span class="ml-2 font-normal">{{ item.label }}</span>
            <i class="pi pi-angle-right text-primary ml-auto"></i>
          </a>
        </ng-template>
      </p-menu>
    </div>
  </div>

  <!-- Reporting Features Section -->
  <div class="landing-page-features">
    <h6 class="landing-page-features-header">Reporting Features</h6>
    <div class="landing-page-features-cards">
      <div class="feature-card">
        <img src="assets/images/calculated-grids.png" alt="Pivot Grids" class="image" />
        <div class="feature-card-text">
          <h6 class="subheading">Pivot Grids</h6>
          <p class="body-text">Dynamically create reports from your selected dimension and measures. Enable quick
            adjustment of calculations used on individual measures.</p>
        </div>
      </div>

      <div class="feature-card">
        <img src="assets/images/calculated-costs.png" alt="Calculated Columns" class="image" />
        <div class="feature-card-text">
          <h6 class="subheading">Calculated Columns</h6>
          <p class="body-text">Use columns in your report to create custom calculations that support your team's
            specific KPIs and metrics.</p>
        </div>
      </div>

      <div class="feature-card">
        <img src="assets/images/optimization.png" alt="Performance Optimization" class="image" />
        <div class="feature-card-text">
          <h6 class="subheading">Performance Optimization</h6>
          <p class="body-text">Utilize our advanced report optimization by leveraging unrestricted data sets for
            building large reports.</p>
        </div>
      </div>
    </div>
  </div>
  <div class="landing-page-connect">
    <p>Connect with us</p>
    <a href="https://www.linkedin.com/company/guideline-ai" target="_blank">
      <img src="assets/images/linkedin-icon.png" alt="Linkedin" />
    </a>
  </div>
</div>